import {CreateData, GetAllData, OTPVerify} from '../CustomNumberSlice/CustomNumberSlice'
import {check} from 'prettier'
import React, {useEffect, useState} from 'react'
import {Modal, Button} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {isLoading, stopLoading} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {getUserData} from '../../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'

const CreateCutomNumber = ({show, handleClose}: any) => {
  const dispatch = useDispatch()

  const userData = useSelector(getUserData)
  const globalLoading = useSelector(isLoading)
  const [name, setName] = useState('')
  const [firstTime, setFirstTime] = useState(true)
  const [verifyOtp, setVerifyOtp] = useState('')
  const [mobile, setMobile] = useState('')
  const [error, setError] = useState({name: '', mobile: ''})
  const [check, setCheck] = useState(false)
  const handleCreate = () => {
    dispatch(CreateData({businessname: name}))
    handleClose()
  }
  const [sendVerificationCode, setSendVerificationCode] = useState(true)

  // init set verification page
  useEffect(() => {
    if (userData && userData.user && userData.user.globalSetting) {
      const globalSettings = userData.user.globalSetting
      if (!Array.isArray(globalSettings)) {
        return
      }

      if (globalSettings.includes('disableSendSenderIdVerificationCode')) {
        setSendVerificationCode(false)
      }
    }
  }, [userData])

  const handleCreateWithoutVerification = () => {
    dispatch(
      CreateData({
        name: name,
        number: mobile,
      })
    ).then((res: any) => {
      if (res?.error === undefined) {
        handleClose()
        setName('')
        setMobile('')
        dispatch(GetAllData())
      }
    })
  }

  const handleValidation = (e: any) => {
    if (e?.target?.name == 'mobile') {
      if (e.target.value == '') {
        setError({...error, mobile: 'Please enter number'})
      } else {
        if (
          !/^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/gm.test(
            e.target.value
          )
        ) {
          setError({...error, mobile: 'Please enter valid number'})
        } else {
          setError({...error, mobile: ''})
        }
      }
    }

    if (e.target.name == 'name') {
      name == '' ? setError({...error, name: 'Please enter name'}) : setError({...error, name: ''})
    }

    e.target.value == '' && setError({...error, [e.target.name]: 'Please fill Field'})
  }

  const handleChange = (e: any) => {
    setMobile(e.target.value)
    setFirstTime(true)
    handleValidation(e)
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName='modal-dialog-centered'>
        <div className='modal-header'>
          <h2 className='fs-2'>Custom number</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-8 px-10'>
          {sendVerificationCode && (
            <p className='mb-0'>
              We first need to verify this is your number. Send a verification, enter it and click
              ”verify”
            </p>
          )}

          <div className='mb-6'>
            <label className=' col-form-label required fw-bold fs-6 pb-2'>Your Name</label>
            <div className='row'>
              <div className='col-12 fv-row mb-5'>
                <input
                  onBlur={handleValidation}
                  type='text'
                  name='name'
                  value={name}
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder='Name'
                  onChange={(e: any) => setName(e.target.value)}
                />
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'>{error?.name}</div>
                </div>
              </div>
            </div>
            <label className=' col-form-label required fw-bold fs-6 pb-2'>Custom Number</label>
            <div className='row'>
              <div className='col-md-8 mb-2 col-lg-12 d-flex align-items-center '>
                <input
                  name='mobile'
                  onBlur={handleValidation}
                  className='form-control form-control-lg form-control-solid'
                  onChange={handleChange}
                  placeholder='+614XXXXXXXX'
                  type={'number'}
                />
                {sendVerificationCode && (
                  <button
                    disabled={error.name !== '' || error.mobile !== ''}
                    onClick={() => {
                      dispatch(
                        CreateData({
                          name: name,
                          number: mobile,
                        })
                      )
                      setFirstTime(false)
                    }}
                    className='btn btn-primary ms-3 text-nowrap'
                  >
                    {firstTime ? 'Send Code' : 'Send Again'}
                  </button>
                )}
              </div>
              <span className='text-muted'>Standard SMS charges apply</span>
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block text-danger'>{error?.mobile}</div>
              </div>
            </div>
            <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 deactivate-account mb-8 mt-8'>
              <KTSVG
                path='/media/icons/duotune/general/gen044.svg'
                className='svg-icon-2tx svg-icon-primary me-4'
              />
              <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                <div className='mb-3 mb-md-0 fw-bold'>
                  <h4 className='text-gray-800 fw-bolder fs-5'>Things to consider</h4>
                  <div className='fs-7 text-gray-600 pe-7'>
                    You won't see replies in your inbox. You'll have to manage the opt-outs yourself
                  </div>
                </div>
              </div>
            </div>
            {sendVerificationCode && (
              <>
                <label className=' col-form-label required fw-bold fs-6 pb-2'>
                  Verification Code
                </label>

                <div className='col-12 mb-4 d-flex align-items-center '>
                  <input
                    max={6}
                    //   maxLength={6}
                    className='form-control form-control-lg form-control-solid'
                    placeholder='Eg. 73817'
                    onChange={(e: any) => {
                      setVerifyOtp(e.target.value)
                    }}
                    type={'number'}
                  />
                  <button
                    disabled={verifyOtp?.length < 6}
                    onClick={() => {
                      dispatch(
                        OTPVerify({
                          name: name,
                          number: mobile,
                          otp: verifyOtp,
                        })
                      ).then((res: any) => {
                        if (res?.error == undefined) {
                          dispatch(GetAllData())
                          handleClose()
                          dispatch(stopLoading())
                          setName('')
                          setMobile('')
                        } else {
                          toast.error('Please enter valid otp')
                          dispatch(stopLoading())
                          setVerifyOtp('')
                        }
                      })
                    }}
                    className='btn btn-primary ms-3'
                  >
                    Verify
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        {!sendVerificationCode && (
          <div className='modal-footer border-top w-100'>
            <Button color='secondary' className='btn-light-primary' onClick={handleClose}>
              Cancel
            </Button>
            <Button
              disabled={name === '' || mobile === '' || error.name !== '' || error.mobile !== ''}
              color='danger'
              onClick={() => handleCreateWithoutVerification()}
            >
              {globalLoading ? (
                <span className='spinner-border spinner-border-xl align-middle ms-2'></span>
              ) : (
                'Send request'
              )}
            </Button>
          </div>
        )}
      </Modal>
    </>
  )
}

export default CreateCutomNumber
